<template>
  <div class="utentiinstallatori">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Lista Installatori</h5>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="5">
          <b-form-group label-cols-sm="2" label="Cerca">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Cerca" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-radio-group v-model="stato" buttons>
            <b-form-radio :value="-1" button-variant="outline-primary">Tutti</b-form-radio>
            <b-form-radio :value="0" button-variant="outline-secondary">In Attesa <b-badge variant="light">{{stato_count(0)}}</b-badge></b-form-radio>
            <b-form-radio :value="1" button-variant="outline-success">Attivato <b-badge variant="light">{{stato_count(1)}}</b-badge></b-form-radio>
            <b-form-radio :value="2" button-variant="outline-dark">Rifiutato <b-badge variant="light">{{stato_count(2)}}</b-badge></b-form-radio>
            <b-form-radio :value="3" button-variant="outline-danger">Scaduto <b-badge variant="light">{{stato_count(3)}}</b-badge></b-form-radio>
            <b-form-radio :value="4" button-variant="outline-warning">In Scadenza <b-badge variant="light">{{stato_count(4)}}</b-badge></b-form-radio>
            <b-form-radio :value="5" button-variant="outline-info">Rinnovato <b-badge variant="light">{{stato_count(5)}}</b-badge></b-form-radio>
            <b-form-radio :value="6" button-variant="outline-dark">Disabilitato <b-badge variant="light">{{stato_count(6)}}</b-badge></b-form-radio>
          </b-form-radio-group>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col>
          <b-table
            :striped="true"
            :hover="true"
            :responsive="true"
            :items="lista_filtrata"
            :fields="campi"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template slot="stato" slot-scope="row">
              <p v-if="row.item.stato == 0">In Attesa</p>
              <p v-if="row.item.stato == 1">Attivato</p>
              <p v-if="row.item.stato == 2">Rifiutato</p>
              <p v-if="row.item.stato == 3">Scaduto</p>
              <p v-if="row.item.stato == 4">In Scadenza</p>
              <p v-if="row.item.stato == 5">Rinnovato</p>
              <p v-if="row.item.stato == 6">Disabilitato</p>
            </template>
            <template slot="action" slot-scope="row">
              <b-button size="sm" variant="info" style="margin-left: 10px;" :to="'/utenti/installatori/visualizza/'+row.item.id" v-b-tooltip.hover title="Visualizza"><font-awesome-icon icon="eye" /></b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'utentiinstallatori',
  data() {
    return {
      lista: [],
      campi: [
        {key: 'denominazione', label: 'Denominazione', sortable: true},
        {key: 'piva', label: 'P. IVA', sortable: true},
        {key: 'cf', label: 'Cod. Fiscale', sortable: true},
        {key: 'stato', label: 'Stato', sortable: true},
        {key: 'indirizzo', label: 'Indirizzo', sortable: true},
        {key: 'scadenza_licenza', label: 'Scadenza', sortable: true},
        {key: 'action', label: '', sortable: false}
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      modal: {
      },
      modalData: {
      },
      stato: -1
    }
  },
  created: function(){
    this.getListaInstallatori()
  },
  methods: {
    getListaInstallatori(){
      Vue.http.post('utente/installatori', {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.lista = response.body.list
          this.totalRows = this.lista.length
        }else{
          this.lista = []
          /*Vue.notify({
              group: 'global',
              title: 'Errore',
              text: "Lista installatori non caricata correttamente.",
              type: 'error'
          })*/
        }
      }, response => {})
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    stato_count(n){
      if(this.lista)
        return this.lista.filter(e => {
          return e.stato == n
        }).length
      return 0
    }
  },
  computed: {
    lista_filtrata: function () {
      if(this.stato != -1){
        var lista = this.lista.filter(e => {
          return e.stato == this.stato
        })

        this.totalRows = lista.length

        return lista
      }
      
      return this.lista
    },
  }
}
</script>


<style scoped>
</style>